/**
 * Invoice Detail Translations (B2B)
 * ==================================
 * Same keys as B2C
 */

import { Translations } from '../shared/i18n';

export const invoiceDetailTranslations: Translations = {
    tr: {
        invoiceDetailTitle: 'Fatura Detay',
        invoiceNotFound: 'Fatura bulunamadı',
        serverError: 'Sunucu bağlantı hatası',

        sectionInvoiceInfo: 'Fatura Bilgileri',
        sectionSupplier: 'Tedarikçi',
        sectionReceiver: 'Alıcı',
        sectionFinancial: 'Finansal',

        fieldInvoiceNumber: 'Fatura No',
        fieldInvoiceType: 'Fatura Tipi',
        fieldInvoiceDate: 'Fatura Tarihi',
        fieldDueDate: 'Vade Tarihi',
        fieldSupplierName: 'Firma Adı',
        fieldTaxId: 'Vergi No',
        fieldAddress: 'Adres',
        fieldEmail: 'E-posta',
        fieldPhone: 'Telefon',
        fieldWebsite: 'Website',
        fieldIban: 'IBAN',
        fieldReceiverName: 'Alıcı Adı',
        fieldReceiverAddress: 'Alıcı Adres',
        fieldTotalAmount: 'Toplam Tutar',
        fieldNetAmount: 'Net Tutar',
        fieldTaxAmount: 'KDV Tutarı',
        fieldCurrency: 'Para Birimi',
        fieldCategory: 'Kategori',

        backToList: 'Listeye Dön',
        highlightOn: 'Highlight ON',
        highlightOff: 'Highlight OFF',
        saveError: 'Kaydetme hatası oluştu.',
        deleteErrorDetail: 'Silme hatası oluştu.',

        deleteTitle: 'Faturayı Sil',
        deleteMessage: 'Bu faturayı kalıcı olarak silmek istediğinize emin misiniz? Bu işlem geri alınamaz.',
        deleteConfirmLabel: 'Sil',
        deleteCancelLabel: 'Vazgeç',
    },
    en: {
        invoiceDetailTitle: 'Invoice Detail',
        invoiceNotFound: 'Invoice not found',
        serverError: 'Server connection error',

        sectionInvoiceInfo: 'Invoice Information',
        sectionSupplier: 'Supplier',
        sectionReceiver: 'Receiver',
        sectionFinancial: 'Financial',

        fieldInvoiceNumber: 'Invoice No',
        fieldInvoiceType: 'Invoice Type',
        fieldInvoiceDate: 'Invoice Date',
        fieldDueDate: 'Due Date',
        fieldSupplierName: 'Company Name',
        fieldTaxId: 'Tax ID',
        fieldAddress: 'Address',
        fieldEmail: 'Email',
        fieldPhone: 'Phone',
        fieldWebsite: 'Website',
        fieldIban: 'IBAN',
        fieldReceiverName: 'Receiver Name',
        fieldReceiverAddress: 'Receiver Address',
        fieldTotalAmount: 'Total Amount',
        fieldNetAmount: 'Net Amount',
        fieldTaxAmount: 'VAT Amount',
        fieldCurrency: 'Currency',
        fieldCategory: 'Category',

        backToList: 'Back to List',
        highlightOn: 'Highlight ON',
        highlightOff: 'Highlight OFF',
        saveError: 'Failed to save changes.',
        deleteErrorDetail: 'Failed to delete invoice.',

        deleteTitle: 'Delete Invoice',
        deleteMessage: 'Are you sure you want to permanently delete this invoice? This action cannot be undone.',
        deleteConfirmLabel: 'Delete',
        deleteCancelLabel: 'Cancel',
    },
};
